import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Badge, FloatButton, Progress, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import CustomHeader from '../header';
import CustomFooter from '../footer';
import UploadVideoModal from '../../components/modal/VideoUpload';

import { setVideoUploadModalOpen, setAudioUploadModalOpen } from '../../redux/slices/modalSlice';

import { BRImages } from '../../assets/imgs';
import PATHS from '../../routes/paths';
import { isMobileDevice } from '../../helpers';
import { useGetVideoDataQuery } from '../../redux/slices/mediaApi';
import UploadAudioModal from '../modal/audioUpload';

const Layout = () => {
  const [isFloatButtonOpen, setIsFloatButtonOpen] = useState(false);
  // const { refetch: refetchVideos } = useGetVideoDataQuery();
  const {
    refetch: refetchVideos,
    isLoading,
    error
  } = useGetVideoDataQuery(
    { page: 1, limit: 10 },
    {
      refetchOnMountOrArgChange: true,
      skip: false
    }
  );

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const {
    isVideoUploading,
    videoUploadProgress,
    isVideoUploadComplete,
    isVideoUploadModalOpen,
    isVideoUploadError,
    isAudioUploading,
    audioUploadProgress,
    isAudioUploadComplete,
    isAudioUploadModalOpen,
    isAudioUploadError
  } = useSelector((state) => state.modal);

  useEffect(() => {
    // Optionally trigger the query when the component mounts
    refetchVideos({ page: 1, limit: 10 });
  }, [refetchVideos]);

  const handleOpenVideoModal = () => {
    dispatch(setVideoUploadModalOpen(true));
    setIsFloatButtonOpen(false);
  };

  const handleOpenAudioModal = () => {
    dispatch(setAudioUploadModalOpen(true));
    setIsFloatButtonOpen(false);
  };

  const handleHelpClick = () => {
    navigate('/help');
    setIsFloatButtonOpen(false);
  };

  const handleVideoUploadModalClose = async () => {
    dispatch(setVideoUploadModalOpen(false));
    setIsFloatButtonOpen(false);
    await refetchVideos({ page: 1, limit: 10 });
  };

  const hideFooter = [PATHS.WEB_CAST_SIGN_IN, PATHS.WEB_CAST_VIDEO]?.includes(location.pathname);
  const shouldShowGroup =
    isVideoUploading ||
    isVideoUploadComplete ||
    isAudioUploading ||
    isAudioUploadComplete ||
    isVideoUploadError ||
    isAudioUploadError;

  const floatingGroupBadgeCount =
    // (isVideoUploadComplete || isVideoUploadError ? 1 : 0) +
    (isAudioUploadComplete || isAudioUploadError ? 1 : 0);
  return (
    <>
      <CustomHeader />
      <main className='space-vertical'>
        <Outlet />
      </main>
      {!hideFooter && <CustomFooter />}
      {/* Floating Button for Help and Uploads */}
      {shouldShowGroup ? (
        <FloatButton.Group
          trigger='click'
          type='primary'
          badge={{
            count: floatingGroupBadgeCount
          }}
          open={isFloatButtonOpen}
          onOpenChange={(open) => setIsFloatButtonOpen(open)}
          icon={
            <img
              src={BRImages.CommonImages.SettingsIcon}
              alt='settings-icon'
              className='settings-icon'
            />
          }
          className={`float-settings-btn ${isFloatButtonOpen ? 'float-settings-btn-close' : 'float-settings-btn-main'
            }`}
        >
          <FloatButton
            shape='circle'
            icon={
              <img
                src={
                  isVideoUploading ||
                    isVideoUploadComplete ||
                    isAudioUploading ||
                    isAudioUploadComplete ||
                    isVideoUploadError ||
                    isAudioUploadError
                    ? BRImages.CommonImages.HelpIconGray
                    : BRImages.CommonImages.HelpIcon
                }
                alt='help-icon'
                className='help-icon'
              />
            }
            type='primary'
            onClick={handleHelpClick}
            tooltip={!isMobileDevice() ? 'Need Help?' : undefined}
            className={`${isVideoUploading ||
              isVideoUploadComplete ||
              isAudioUploading ||
              isAudioUploadComplete ||
              isVideoUploadError ||
              isAudioUploadError
              ? 'bookroad-help-btn-white'
              : 'bookroad-help-btn'
              }`}
          />
          {/* Video Upload Floating Button */}
          {/* {(isVideoUploading || isVideoUploadComplete || isVideoUploadError) && (
            <FloatButton
              shape='circle'
              badge={{
                dot: isVideoUploading || isVideoUploadComplete || isVideoUploadError
              }}
              icon={
                isVideoUploading ? (
                  <Progress percent={videoUploadProgress} type='circle' width={40} />
                ) : isVideoUploadComplete ? (
                  <img
                    src={BRImages.CommonImages.SuccessIcon}
                    alt='upload-complete-icon'
                    className='alert-icon'
                  />
                ) : isVideoUploadError ? (
                  <Tooltip title='Upload Failed'>
                    <span style={{ color: 'red' }}>!</span>
                  </Tooltip>
                ) : (
                  <Badge count={isVideoUploadComplete ? 1 : 0}>
                    <span>Video Upload</span>
                  </Badge>
                )
              }
              onClick={handleOpenVideoModal}
              tooltip={!isMobileDevice() ? 'Video Upload Progress' : undefined}
              className='bookroad-float-btn'
            />
          )} */}
          {/* Audio Upload Floating Button */}
          {(isAudioUploading || isAudioUploadComplete || isAudioUploadError) && (
            <FloatButton
              shape='circle'
              badge={{
                dot: isAudioUploading || isAudioUploadComplete || isAudioUploadError
              }}
              icon={
                isAudioUploading ? (
                  <Progress percent={audioUploadProgress} type='circle' width={40} />
                ) : isAudioUploadComplete ? (
                  <img
                    src={BRImages.CommonImages.SuccessIcon}
                    alt='upload-complete-icon'
                    className='alert-icon'
                  />
                ) : isAudioUploadError ? (
                  <Tooltip title='Upload Failed'>
                    <span style={{ color: 'red' }}>!</span>
                  </Tooltip>
                ) : (
                  <Badge count={isAudioUploadComplete ? 1 : 0}>
                    <span>Audio Upload</span>
                  </Badge>
                )
              }
              onClick={handleOpenAudioModal}
              tooltip={!isMobileDevice() ? 'Audio Upload Progress' : undefined}
              className='bookroad-float-btn'
            />
          )}
        </FloatButton.Group>
      ) : (
        <FloatButton
          shape='circle'
          icon={<img src={BRImages.CommonImages.HelpIcon} alt='help-icon' className='help-icon' />}
          type='primary'
          onClick={handleHelpClick}
          tooltip={!isMobileDevice() ? 'Need Help?' : undefined}
          className='bookroad-help-btn'
        />
      )}
      {/* Upload Video Modal */}
      <UploadVideoModal
        visible={isVideoUploadModalOpen}
        onClose={handleVideoUploadModalClose}
        loading={isVideoUploading}
        mediaType='video'
      />
      {/* Upload Audio Modal */}
      <UploadAudioModal
        visible={isAudioUploadModalOpen}
        onClose={() => dispatch(setAudioUploadModalOpen(false))}
        loading={isAudioUploading}
        mediaType='audio'
      />
    </>
  );
};

export default React.memo(Layout);
